import React from "react";
import { Helmet } from "react-helmet";

const ProfileSEO = () => {
  return (

       <Helmet>
         {/* Page title optimized for the profile page */}
         <title>Betpro Wallet Profile - Manage Your Account</title>

         <link rel="icon" href="https://betprowallet.net/favicon.ico" />

         {/* Canonical tag */}
         <link rel="canonical" href="https://betprowallet.net/profile" />

         {/* Meta description focusing on managing user profiles */}
         <meta name="description" content="Manage your Betpro Wallet profile and account settings. ⚽️ Update your personal information, check your balance, track your bets, and manage withdrawals. Secure and easy profile management at Betprowallet.net." />

         {/* Meta keywords for search engine optimization */}
         <meta name="keywords" content="Betpro Wallet profile, manage Betpro Wallet account, Betpro Wallet personal information, check balance, track bets, Betpro Wallet withdrawals, Betprowallet.net profile" />

         {/* Meta author */}
         <meta name="author" content="Betpro Wallet" />

         {/* Open Graph meta tags for social media sharing */}
         <meta property="og:title" content="Betpro Wallet Profile - Manage Your Account" />
         <meta property="og:description" content="Access and manage your Betpro Wallet profile. Update personal information, view your betting history, check your account balance, and manage your withdrawals." />
         <meta property="og:url" content="https://betprowallet.net/profile" />
         <meta property="og:type" content="website" />
         <meta property="og:image" content="https://betprowallet.net/bpthumb1.jpg" />

         {/* Twitter Card for sharing on Twitter */}
         <meta name="twitter:card" content="summary_large_image" />
         <meta name="twitter:title" content="Betpro Wallet Profile - Manage Your Account" />
         <meta name="twitter:description" content="Manage your Betpro Wallet account and update your profile information. Track your bets, check your balance, and manage your withdrawals at Betprowallet.net." />
         <meta name="twitter:image" content="https://betprowallet.net/bpthumb1.jpg" />

         {/* Structured Data for SEO */}
         <script type="application/ld+json">
           {`
       {
         "@context": "https://schema.org",
         "@type": "WebPage",
         "name": "Betpro Wallet Profile - Manage Your Account",
         "url": "https://betprowallet.net/profile",
         "description": "Manage your Betpro Wallet profile and account. Update personal details, check balance, track bets, and manage withdrawals securely on Betpro Wallet.",
         "publisher": {
           "@type": "Organization",
           "name": "Betpro Wallet"
         }
       }
     `}
         </script>
       </Helmet>

  );
};

export default ProfileSEO;
